<template>
  <PagePaper>
    <div class="d-flex justify-end mb-4">
      <IconButtonText @click="generateMonthResults()" :text="$t('management.resultReport.buttonGenerate')" />
    </div>
    <div>
      <v-data-table
        :loading-text="table.loadingText"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        hide-default-footer
        class="tableReport"
      >
        <template v-slot:[`item.month`]="{ item }">
          {{ $moment(item.date).format('MMMM') }}
        </template>
        <template v-slot:[`header.sale`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.sale`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.sale) }}</div>
        </template>
        <template v-slot:[`header.collection`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.collection`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.payment) }}</div>
        </template>
        <template v-slot:[`header.purchase`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.purchase`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.purchaseTotal) }}</div>
        </template>
        <template v-slot:[`header.paidPurchase`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.paidPurchase`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.paidPurchase) }}</div>
        </template>
        <template v-slot:[`header.expense`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.expense`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.expenseTotal) }}</div>
        </template>
        <template v-slot:[`header.paidExpense`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.paidExpense`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.paidExpense) }}</div>
        </template>
        <template v-slot:[`header.result`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.result`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.result) }}</div>
        </template>
        <template v-slot:[`header.flow`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.flow`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.flow) }}</div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  x-small
                  depressed
                  target="_blank"
                  @click="updateReport(item._id)"
                  class="blueButton"
                >
                  <v-icon>mdi-sync</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('management.resultReport.table.updateReport') }}</span>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:footer="">
          <Pagination
            :itemsPerPage="table.options.itemsPerPage"
            :page="table.options.page"
            :total="totalRecords"
          />
        </template>
      </v-data-table>
    </div>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </PagePaper>
</template>

<script>
import Pagination from '@/components/elements/Pagination'
import PagePaper from '@/components/elements/PagePaper'
import IconButtonText from '@/components/elements/IconButtonText'
import formatCurrency from '@/utils/formatCurrency'

export default {
  name: 'ResultReport',
  components: {
    Pagination,
    PagePaper,
    IconButtonText
  },
  data () {
    return {
      overlay: false,
      table: {
        loadingText: this.$i18n.t('management.resultReport.table.loadingText'),
        loading: false,
        headers: [
          { text: this.$i18n.t('management.resultReport.table.headers.month'), value: 'month', sortable: false },
          { text: this.$i18n.t('management.resultReport.table.headers.sale'), value: 'sale', sortable: false },
          { text: this.$i18n.t('management.resultReport.table.headers.collection'), value: 'collection', sortable: false },
          { text: this.$i18n.t('management.resultReport.table.headers.purchase'), value: 'purchase', sortable: false },
          { text: this.$i18n.t('management.resultReport.table.headers.paidPurchase'), value: 'paidPurchase', sortable: false },
          { text: this.$i18n.t('management.resultReport.table.headers.expense'), value: 'expense', sortable: false },
          { text: this.$i18n.t('management.resultReport.table.headers.paidExpense'), value: 'paidExpense', sortable: false },
          { text: this.$i18n.t('management.resultReport.table.headers.result'), value: 'result', sortable: false },
          { text: this.$i18n.t('management.resultReport.table.headers.flow'), value: 'flow', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      }
    }
  },
  mounted () {
    this.loadReports()
  },
  computed: {
    totalRecords () {
      return this.table.data.length
    }
  },
  methods: {
    // Todo: integrate api
    loadReports: async function () {
      const restauratId = this.$store.state.currentRestaurant.data._id
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/reports/${restauratId}/accounting/results`)
        // const {
        //   payOrdersReceived,
        //   paidOrders,
        //   pendingPaymentOrders,
        //   ordersWithOutSupport,
        //   outgoingCategories
        // } = response
        // let dataItems = []
        // dataItems.push({
        //   expense: this.$i18n.t('management.expensesReport.table.expenses.payOrdersReceived'),
        //   ...payOrdersReceived
        // })
        // dataItems.push({
        //   expense: this.$i18n.t('management.expensesReport.table.expenses.paidOrders'),
        //   ...paidOrders
        // })
        // dataItems.push({
        //   expense: this.$i18n.t('management.expensesReport.table.expenses.pendingPaymentOrders'),
        //   ...pendingPaymentOrders
        // })
        // dataItems.push({
        //   expense: this.$i18n.t('management.expensesReport.table.expenses.ordersWithoutSupport'),
        //   ...ordersWithOutSupport
        // })
        // outgoingCategories.forEach(({ name, ...rest }) => dataItems.push({ expense: name, ...rest }))
        // this.table.data = dataItems
        this.table.data = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    formatCurrency,
    // Todo: download file
    downloadReport (id) {
      // let url = `${process.env.VUE_APP_API_URL}/v1/invoices/${id}/download-invoice-pdf`
      // url += `?access_token=${this.$store.state.login.token}`

      // return url
    },
    generateMonthResults: async function () {
      const restauratId = this.$store.state.currentRestaurant.data._id
      const payload = {
        date: this.$moment(new Date()).format('YYYY-MM-DD')
      }

      this.overlay = true
      try {
        await this.$api.post(`/v1/reports/${restauratId}/accounting`, payload)
        this.loadReports()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    updateReport: async function (reportId) {
      const restauratId = this.$store.state.currentRestaurant.data._id

      this.overlay = true
      try {
        await this.$api.put(`/v1/reports/${restauratId}/accounting/${reportId}`)
        this.loadReports()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .tableReport {
    th {
      font-size: 12px;
    }

    td {
      font-size: 12px;
    }
  }

  .blueButton {
    background-color: #0F6FFF !important;
    color: #fff !important;
  }
</style>
